import templateData from './getTemplateData';

export const appendCdnHostName = (url) => {
  return `${templateData.cdnHostName}${url}`;
};
